module.exports = {
  /* 01.General */
  "chat.end":"Starten Sie Ihr Chat-Gespräch neu",
  "chat.endall":"Ende des Gesprächs",
  "chat.cancel":"Abbrechen",
  "chat.cookie":"Dieser digitale Assistent verwendet Cookies, um sicherzustellen, dass Sie die beste Erfahrung machen",
  "chat.learn":"Mehr erfahren",
  "chat.minimize":"Minimieren",
  "chat.hide":"Nah dran",
  "chat.hidebot.text":"Schließen lässt den Avatar für 15 Minuten verschwinden",
  "chat.hidebot":"Bot schließen",
  "chat.restart":"Neu starten",
  "switch.language":"Sprache wechseln",
  "switch.property":"Eigenschaften wechseln",
  "restart.converstation":"Starten Sie die Konvertierung neu",
  "chat.endtext":"Möchten Sie den aktuellen Chat wirklich beenden?",
  "check.availabity":"Verfügbarkeit prüfen",
  "check.availabity.submit":"Einreichen",
  "check.availabity.cancel":"Absagen",
  "check.availabity.adults":"Erwachsene ",
  "check.availabity.children":"Kinder",
  "check.availabity.child.age":"Alter - Kind",
  "feedback.leave":"Hinterlasse Kommentar",
  "feedback.leave.message":"Nachricht hinterlassen",
    "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email" :" Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode":"Zip Code"
};
